import { helpers } 	from './theme/helpers.js';
import { sliders } 	from './theme/components/sliders.js';
import { search } 	from './theme/components/search.js';
import { profile } 	from './theme/components/profile.js';
import { header } 	from './theme/components/header.js';
import { langs } 	from './theme/components/langs.js';
import { map } 		from './theme/components/map.js';
import { register } from './theme/components/register.js';


window.theme = {
	globals: {
		isTouch: typeof window !== 'undefined' && 'ontouchstart' in window,
		isTabActive: true,
	},
	
	init: function () {
		var self = this;

		// internal
		self.dateLimited();
		self.inlineYoutube();
		self.playVideo();
		self.loadTabs();
		self.sharePage();
		self.smoothSroll();
		self.wrapTables();

		// external
		sliders.init();
		search.init();
		profile.init();
		header.init();
		langs.init();
		map.init();
		register.init();

		jQuery( '[href="#form-contact"]' ).on( 'click', function(){
			jQuery.fancybox.open({
				src: '#form-contact',
				type : 'inline',
				touch: false,
			});
		});
	},

	wrapTables: function(){
		jQuery('.article-layout .possible-text-content > table').each(function() {
			jQuery(this).wrap('<div class="wrap-table"></div>');
		});
	},

	sharePage: function() {
		const urls = {
			x: 'http://twitter.com/share?text=[TITLE]&url=[URL]',
			facebook: 'http://www.facebook.com/sharer.php?u=[URL]&t=[TITLE]',
			pinterest: 'http://pinterest.com/pin/create/button/?url=[URL]&description=[TITLE]',
			linkedin: 'https://www.linkedin.com/shareArticle?mini=true&url=[URL]&title=[TITLE]',
		};

		jQuery( '[data-sikmon="share"]' ).on( 'click', function( event ){
			event.preventDefault();

			jQuery.fancybox.open({
				src: '#share-modal',
				type : 'inline',
				touch: false,
			});
		});

		jQuery( '.share-modal .fancybox-modal__main .button' ).on( 'click', function( event ){
			event.preventDefault();

			let type = jQuery( this ).attr( 'data-type' );
			let url = urls[ type ].replace( '[URL]', encodeURI( window.location.href ) ).replace( '[TITLE]', encodeURI( document.title ) );

			// console.log( url );
			window.open( url, '_blank' );
		});
	},

	smoothSroll: function() {
		jQuery('.blocks .block a[href*="#"]:not([href="#"])').on( 'click', function(event) {
			if (jQuery(this).closest( '.js-profileTabs' ).length != 0) {
				return;
			}
			
			// Check if the clicked link's destination is on the same page
			if (location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') && location.hostname === this.hostname) {
				// Find the target element
				var target = jQuery(this.hash);
				target = target.length ? target : jQuery('[name=' + this.hash.slice(1) + ']');
				// If the target exists, perform the smooth scroll
				if (target.length) {
					// Prevent the default action of the link
					event.preventDefault();
					jQuery('html, body').animate({
						scrollTop: target.offset().top
					}, 1000, function() {
						// Callback after animation
						// Change focus to the target element (for accessibility reasons)
						var $target = jQuery(target);
						$target.focus();
						if ($target.is(":focus")) { // Checking if the target was focused
							return false;
						} else {
							$target.attr('tabindex', '-1'); // Adding tabindex for elements not focusable
							$target.focus(); // Set focus again
						};
					});
				}
			}
		});
	},

	playVideo: function() {
		if( document.querySelectorAll( '.block-video__wrapper' ).length == 0 ) {
			return false;
		}

		document.querySelectorAll( '.block-video__wrapper' ).forEach(videoWrapper => {
			if( ! videoWrapper.querySelector( 'video' ) || ! videoWrapper.querySelector( 'video' ) ) {
				return;
			}

			const video = videoWrapper.querySelector( 'video' );

			const button = videoWrapper.querySelector( 'button' ).addEventListener( 'click', (e) => {
				if( videoWrapper.closest( '.block-video' ).classList.contains( 'playing' ) ) {
					video.pause();
				} else {
					video.play();
				}

				videoWrapper.closest( '.block-video' ).classList.toggle( 'playing' );
			});
		});
	},

	inlineYoutube: function () {
		if( document.querySelectorAll( '.youtube-inline-player' ).length == 0 ) {
			return false;
		}

		document.querySelectorAll( '.youtube-inline-player' ).forEach(videoWrapper => {
			videoWrapper.addEventListener( 'click', (event) => {

				var videoId = videoWrapper.getAttribute('data-youtube');
				videoWrapper.classList.add('played');

				videoWrapper.innerHTML = '<iframe src="https://www.youtube.com/embed/' + videoId + '?autoplay=1&mute=0&rel=0&" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen class="parent-background"></iframe>';
			});
		});
	},

	loadTabs: function() {
		var self = this;

		if( document.querySelectorAll( '.js-basicTabs a' ).length == 0 ) {
			return false;
		}
		
		document.querySelectorAll( '.js-basicTabs a' ).forEach(function( button, item ){
			button.addEventListener( 'click', (e) => {
				e.preventDefault();

				let anchor = e.target.getAttribute( 'href' ).replace( '#', '' );
				self.switchTab( anchor );
			});
		});
	},

		switchTab: function( toTab ) {
			var self = this;

			if( ! document.querySelector( `#${toTab}` ) ) {
				return false;
			}

			document.querySelector( '.js-basicTabs li.active' ).classList.remove( 'active' );
			document.querySelector( '.tabs__content.active' ).classList.remove( 'active' );
			
			document.querySelector( `.js-basicTabs li:has( a[href="#${toTab}"] )` ).classList.add( 'active' );
			document.querySelector( `#${toTab}.tabs__content` ).classList.add( 'active' );
		},

	dateLimited: function() {
		var self = this;
	
		const today 	= new Date();
		const elements 	= document.querySelectorAll( '[data-limitedstart][data-limitedend]' );
		const isEvent 	= document.querySelector( 'body' ).classList.contains( 'single-event' );
	
		elements.forEach(element => {
			const startDate = self.parseDate( element.getAttribute( 'data-limitedstart' ) );
			const endDate 	= self.parseDate( element.getAttribute ('data-limitedend' ) );

			if( isEvent ) {
				let showRow = self.viewDate( today, element, startDate, endDate );
				
				if( showRow ) {
					element.removeAttribute( 'data-limitedstart' );
					element.removeAttribute( 'data-limitedend' );
				}
				
				return false;
			}

			// basic
			if ( today >= startDate && today <= endDate ) {
				element.removeAttribute( 'data-limitedstart' );
				element.removeAttribute( 'data-limitedend' );
			}			
		});
	},

		viewDate: function( date, element, startDate, endDate ) {
			let finalDate = null;

			if( startDate == 'Invalid Date' && endDate == 'Invalid Date' ) {
				return false;
			}

			if( startDate != 'Invalid Date' && endDate == 'Invalid Date' ) {
				finalDate = startDate.setDate( startDate.getDate() + 1 );
			}
			
			if( startDate == 'Invalid Date' && endDate != 'Invalid Date' ) {
				finalDate = endDate;
			}

			if( startDate != 'Invalid Date' && endDate != 'Invalid Date' ) {
				finalDate = endDate;
			}

			if( finalDate > date ) {
				return true;
			}

			return false;
		},

		parseDate: function(dateString) {
			var self = this;

			const parts = dateString.split("/");
			return new Date(parts[2], parts[1] - 1, parts[0]);
		},
};

jQuery(document).ready(function ($) {
	theme.init();
});